"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var trash;
        (function (trash) {
            var index;
            (function (index_1) {
                class InitArgs {
                    constructor() {
                        this.dateFilter = appn.emptyString;
                        this.userGroups = [];
                        this.users = [];
                        this.types = [];
                        this.trashRestore = appn.emptyString;
                    }
                }
                let _initArgs;
                let selectedItems;
                let dataTable = null;
                function init(args) {
                    _initArgs = args;
                    createDataTable();
                    appn.dateFilter.init(_initArgs.dateFilter);
                    addEvents();
                }
                index_1.init = init;
                function addEvents() {
                    $('form button[name="submitType"]').filter(function () {
                        if (this.value.containsIgnoreCase('restore'))
                            return true;
                        return false;
                    }).off().on('click', function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        const preventAutoModalHide = $(this).data('preventautomodalhide');
                        if (!preventAutoModalHide)
                            appn.dialog.hide();
                        const submitType = this.value;
                        const $parentForm = $(this).closest('form');
                        let restoreMessage = T('Item(s) will be restored to their original location in the system. Do you still want to proceed?');
                        const restoreMessageOverride = $(this).data('restoremessage');
                        if (restoreMessageOverride && restoreMessageOverride.trim().length > 0)
                            restoreMessage = restoreMessageOverride;
                        appn.dialog.confirm({
                            modalColor: 'modal-info',
                            title: T('Restore Item(s) from Trash?'),
                            message: restoreMessage,
                            buttons: {
                                confirm: {
                                    label: '<span>' + T('OK') + '</span>',
                                    className: 'btn-success'
                                }
                            },
                            callback: function (result) {
                                if (result) {
                                    $parentForm.append('<input type="hidden" name="submitType" value="' + submitType + '" />');
                                    $parentForm.submit();
                                    return;
                                }
                                $('#TrashToManage').val(appn.emptyString);
                            }
                        });
                    });
                }
                function hasGroups() {
                    return _initArgs.userGroups.length > 0;
                }
                function createDataTable() {
                    dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'Trash/DataTable',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', $('#sCustom_0').val()), appn.dataTable.getStateOrDefault('sCustom_1', $('#sCustom_1').val()), { name: 'sCustom_3', value: appn.dateFilter.getStateOrDefaultAsString() });
                            if (hasGroups())
                                data.push(appn.dataTable.getStateOrDefault('sCustom_2', $('#sCustom_2').val()));
                        },
                        aaSorting: [[3, 'desc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '60%' },
                            { bSortable: true, sWidth: '20%' },
                            { bSortable: true, sWidth: '15%' }
                        ],
                        fnInitComplete: function () {
                            if (hasGroups())
                                $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.userGroups, 'sCustom_2', 'saveMeState form-control-sm form-control userGroupsFilter'));
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildAppnSelect(_initArgs.users, 'sCustom_1', 'saveMeState form-control-sm form-control usersFilter'));
                            $('.dataTables_filter').prepend(appn.elementBuilder.buildSelect(_initArgs.types, 'sCustom_0', 'saveMeState form-control-sm form-control', T('ALL TYPES')));
                            appn.actionButtons.renderNavbarActionButtons([
                                { buttonId: 'manageBtn', buttonType: 'Manage', isDataTableToggleBtn: true }
                            ], appn.requestUser.isUserOrHigher, true);
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            $('#manageBtn').click(function (e) {
                                e.preventDefault();
                                if ($(this).css('opacity') === '1') {
                                    selectedItems = $('.selectRow:checked');
                                    let trashIds = '';
                                    $(selectedItems).map(function () {
                                        trashIds += ($(this).attr('id')) + ',';
                                    });
                                    $('#TrashToManage').val(trashIds);
                                    $('#manageTrashDialog').modal('show');
                                    const submitButton = $('#manageTrashDialog .card-header button[value="Manage_Delete"].btn-danger');
                                    createDeleteMessageFromTable(submitButton, selectedItems, 1, 2);
                                }
                            });
                            appn.dataTable.addSearchPlaceholder(T('Filter results where Trash <b>Name, Type, User First Name or Last Name</b> contains a keyword typed in here.'));
                            appn.saveMeState.init(function () {
                                dataTable.fnDraw(false);
                            }, function () {
                                dataTable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            $('.trash-restore').off().on('click', function () {
                                const trashId = $(this).data('trash-id');
                                appn.dialog.confirm({
                                    modalColor: 'modal-info',
                                    title: T('Restore Item from Trash?'),
                                    message: T(`This item will be restored to its original location in the system.<br><br>Do you still want to proceed?`),
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            appn.location.navTo(_initArgs.trashRestore, [
                                                { name: 'TrashToManage', value: trashId },
                                                { name: 'submitType', value: 'Restore' }
                                            ]);
                                    }
                                });
                            });
                            $('.trash-delete').off().on('click', function () {
                                const trashId = $(this).data('trash-id');
                                appn.dialog.confirm({
                                    modalColor: 'modal-danger',
                                    title: T('Permanently Delete This Item?'),
                                    message: T('This item will be <b>permanently deleted</b> with <b>no option</b> to recover this data.<br><br>Do you still want to proceed?'),
                                    buttons: {
                                        confirm: {
                                            label: '<span>' + T('OK') + '</span>',
                                            className: 'btn-success'
                                        }
                                    },
                                    callback: function (result) {
                                        if (result)
                                            appn.location.navTo(_initArgs.trashRestore, [
                                                { name: 'TrashToManage', value: trashId },
                                                { name: 'submitType', value: 'Delete' }
                                            ]);
                                    }
                                });
                            });
                        }
                    });
                }
                function createDeleteMessageFromTable(button, selectedRows, nameCol, typeCol) {
                    let msg;
                    button.attr('data-deletedetail', appn.emptyString);
                    button.attr('data-deletemessage', appn.emptyString);
                    if (selectedRows.length > 1) {
                        const ul = appn.elementBuilder.createElement('ul', (selectedRows.length > 5 ? 'scroller' : undefined));
                        selectedRows.each(function (index, selected) {
                            const name = $($(selected).closest('tr').find('td')[nameCol]).clone()
                                .children()
                                .remove()
                                .end()
                                .text()
                                .trim();
                            const type = $($(selected).closest('tr').find('td')[typeCol]).text();
                            const li = appn.elementBuilder.createElement('li', undefined, undefined, undefined, `<b>${type}: ${name}</b>`);
                            ul.appendChild(li);
                        });
                        msg = T('The following <b>Items</b> are about to be deleted.') + ul.outerHTML;
                    }
                    else {
                        const name = $($(selectedRows[0]).closest('tr').find('td')[nameCol]).clone()
                            .children()
                            .remove()
                            .end()
                            .text()
                            .trim();
                        const type = $($(selectedRows[0]).closest('tr').find('td')[typeCol]).text();
                        msg = T('<b>{0}: {1}</b> is about to be deleted.', type, name);
                    }
                    const p = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msg);
                    const msgWarning = T('The selected item(s) will be <b>permanently deleted</b> with <b>no option</b> to recover this data.');
                    const p2 = appn.elementBuilder.createElement('p', undefined, undefined, undefined, msgWarning);
                    button.attr('data-deletedetail', JSON.stringify(p.outerHTML));
                    button.attr('data-deletemessage', p2.outerHTML);
                }
            })(index = trash.index || (trash.index = {}));
        })(trash = views.trash || (views.trash = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
